export enum EOrderProductionStatus {
    PENDING = 0,
    ACTIVE = 1,
    FINISHED = 2,
    CANCELED = 3,
}
